class CashLimitUploadOutcome {
    constructor(outcome) {
        this.outcome = outcome;
        this.className = `outcome-${outcome.toLowerCase().replace(/_/g, '-')}`;
    }

    translate(t) {
        return t(`cash-limits.outcome.${this.outcome.toLowerCase().replace(/_/g, '-')}`);
    }
}

export const SUCCESS = new CashLimitUploadOutcome('SUCCESS');
export const LIMIT_FAILURE = new CashLimitUploadOutcome('LIMIT_FAILURE');
export const DUPLICATED_MAIN_ID = new CashLimitUploadOutcome('DUPLICATED_MAIN_ID');
export const OLD_EXPORT = new CashLimitUploadOutcome('OLD_EXPORT');

export const getCashLimitUploadOutcome = (outcome) => {
    let result = null;
    switch (outcome) {
        case 'SUCCESS':
            result = SUCCESS;
            break;
        case 'LIMIT_FAILURE':
            result = LIMIT_FAILURE;
            break;
        case 'DUPLICATED_MAIN_ID':
            result = DUPLICATED_MAIN_ID;
            break;
        case 'OLD_EXPORT':
            result = OLD_EXPORT;
            break;
        default:
            throw new Error(`Unknown outcome: ${outcome}`);
    }
    return result;
};

export const getAllUploadOutcomes = () => [
    SUCCESS,
    LIMIT_FAILURE,
    DUPLICATED_MAIN_ID,
    OLD_EXPORT,
];
